// Utils
import { component } from 'picoapp';

import { repaint } from 'utils/node';

export default component(async (node) => {
  const classes = {
    subnavigation: {
      active: 'drawer__subdrawer--active',
    },
  };

  const triggers = node.querySelectorAll('[data-trigger]');
  const subdrawers = [...node.querySelectorAll('[data-name]')];

  triggers.forEach((trigger) => {
    const subdrawer = subdrawers.find((item) => item.dataset.name === trigger.dataset.trigger);

    trigger.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const isHidden = subdrawer.hidden === true;

        if (isHidden) {
          subdrawer.hidden = false;
          repaint(subdrawer);

          subdrawer.classList.add(classes.subnavigation.active);
        } else {
          subdrawer.classList.remove(classes.subnavigation.active);

          subdrawer.addEventListener(
            'transitionend',
            () => {
              subdrawer.hidden = true;
            },
            { once: true },
          );
        }
      },
      { capture: true },
    );
  });
});
